module.exports = __webpack_public_path__ + "icon_arrow_go_external.8a591.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_arrow_go_external.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_arrow_go_external.svg
// module chunks = main